/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { Country } from './Country'
import { CountryFromJSON, CountryFromJSONTyped, CountryToJSON } from './Country'

/**
 *
 * @export
 * @interface GetCountries200Response
 */
export interface GetCountries200Response {
  /**
   *
   * @type {boolean}
   * @memberof GetCountries200Response
   */
  status: boolean
  /**
   *
   * @type {Array<Country>}
   * @memberof GetCountries200Response
   */
  data: Array<Country>
}

/**
 * Check if a given object implements the GetCountries200Response interface.
 */
export function instanceOfGetCountries200Response(
  value: object
): value is GetCountries200Response {
  if (!('status' in value) || value['status'] === undefined) return false
  if (!('data' in value) || value['data'] === undefined) return false
  return true
}

export function GetCountries200ResponseFromJSON(
  json: any
): GetCountries200Response {
  return GetCountries200ResponseFromJSONTyped(json, false)
}

export function GetCountries200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetCountries200Response {
  if (json == null) {
    return json
  }
  return {
    status: json['status'],
    data: (json['data'] as Array<any>).map(CountryFromJSON),
  }
}

export function GetCountries200ResponseToJSON(
  value?: GetCountries200Response | null
): any {
  if (value == null) {
    return value
  }
  return {
    status: value['status'],
    data: (value['data'] as Array<any>).map(CountryToJSON),
  }
}
